import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import authCopy from "../data/private/auth.json";
import { useAuth } from "../context/AuthContext";
import { logActivity } from "../utils/activity";

export default function Signup() {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { signup } = useAuth();

  const emailValue = form.email.trim();
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
  const isValid = isValidEmail && form.password.trim().length >= 4;

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isValid) {
      setError(authCopy.signup.error);
      return;
    }
    if (isSubmitting) {
      return;
    }
    setError("");
    setIsSubmitting(true);
    const result = await signup({
      email: emailValue,
      password: form.password.trim(),
    });
    if (!result.ok) {
      setError(result.message || authCopy.signup.error);
      setIsSubmitting(false);
      return;
    }
    logActivity("auth_signup", { email: emailValue });
    navigate("/otp-verification");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="section-padding mx-auto w-full max-w-lg">
        <div className="card space-y-4 p-6">
          <h1 className="page-title text-2xl">{authCopy.signup.title}</h1>
          <p className="text-sm text-slate-600">{authCopy.signup.subtitle}</p>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="text-sm font-medium text-slate-700">
                {authCopy.signup.fields.emailLabel}
              </label>
              <input
                className="mt-2 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                placeholder={authCopy.signup.fields.emailPlaceholder}
                value={form.email}
                onChange={(event) => handleChange("email", event.target.value)}
              />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700">
                {authCopy.signup.fields.passwordLabel}
              </label>
              <input
                className="mt-2 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                placeholder={authCopy.signup.fields.passwordPlaceholder}
                type="password"
                value={form.password}
                onChange={(event) => handleChange("password", event.target.value)}
              />
            </div>
            {error && <p className="text-sm text-rose-500">{error}</p>}
            <button
              className="btn btn-primary w-full"
              disabled={!isValid || isSubmitting}
            >
              {authCopy.signup.submitLabel}
            </button>
            {isSubmitting && (
              <p className="text-xs text-slate-500">
                {authCopy.signup.loading}
              </p>
            )}
          </form>
          <p className="text-sm text-slate-600">
            {authCopy.signup.footerPrompt}{" "}
            <NavLink to="/login" className="text-amber-600">
              {authCopy.signup.footerLinkLabel}
            </NavLink>
          </p>
        </div>
      </section>
    </div>
  );
}
